import { configureStore } from "@reduxjs/toolkit";
import apiSlice from "../features/api/apiSlice";
import projectReducer from "../features/Projects/projectSlice";
import taskReducer from "../features/Task/taskSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    projects: projectReducer,
    tasks: taskReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
